import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { Select } from 'SRC/ui/FormElements'
import { getUserInfo } from '../../../../../selectors'

export class WorkingTime extends React.Component {
  workingHours = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23]
  getMonFriFromField = () => ({
    id: `monfriFrom-${this.props.index}`,
    name: `userAddresses[${this.props.index}].monfriFrom`,
    options: this.prepareWorkingHours(),
    label: 'PON - PET',
    labelDefault: 'od',
    className: 'item'
  })

  getMonFriToField = () => ({
    id: `monfriTo-${this.props.index}`,
    name: `userAddresses[${this.props.index}].monfriTo`,
    options: this.prepareWorkingHours(),
    label: '',
    labelDefault: 'do',
    className: 'item',
    needColon: false
  })

  getSaturdayFromField = () => ({
    id: `saturdayFrom-${this.props.index}`,
    name: `userAddresses[${this.props.index}].saturdayFrom`,
    options: this.prepareWorkingHours(),
    label: 'SUBOTA',
    labelDefault: 'od',
    className: 'item'
  })

  getSaturdayToField = () => ({
    id: `saturdayTo-${this.props.index}`,
    name: `userAddresses[${this.props.index}].saturdayTo`,
    options: this.prepareWorkingHours(),
    label: '',
    labelDefault: 'do',
    className: 'item',
    needColon: false
  })

  getSundayFromField = () => ({
    id: `sundayFrom-${this.props.index}`,
    name: `userAddresses[${this.props.index}].sundayFrom`,
    options: this.prepareWorkingHours(),
    label: 'NEDELJA',
    labelDefault: 'od',
    className: 'item'
  })

  getSundayToField = () => ({
    id: `sundayTo-${this.props.index}`,
    name: `userAddresses[${this.props.index}].sundayTo`,
    options: this.prepareWorkingHours(),
    label: '',
    labelDefault: 'do',
    className: 'item',
    needColon: false
  })

  prepareWorkingHours = () => this.workingHours.map(item => {
    const label = item < 10 ? `0${item}:00` : `${item}:00`
    return {
      id: item,
      label,
      value: label,
      isDisabled: false
    }
  })

  render () {
    const monFriFrom = this.getMonFriFromField()
    const monFriTo = this.getMonFriToField()
    const saturdayFrom = this.getSaturdayFromField()
    const saturdayTo = this.getSaturdayToField()
    const sundayFrom = this.getSundayFromField()
    const sundayTo = this.getSundayToField()
    return [
      <div className='radno-vreme-od' key='workingTimeFrom'>
        <Select {...monFriFrom} />
        <Select {...saturdayFrom} />
        <Select {...sundayFrom} />
      </div>,
      <div className='radno-vreme-do' key='workingTimeTo'>
        <Select {...monFriTo} />
        <Select {...saturdayTo} />
        <Select {...sundayTo} />
      </div>
    ]
  }
}

const mapStateToProps = (state, props) => {
  const result = {}
  const userInfo = getUserInfo(state)
  if (
    props.index >= 0 &&
    userInfo &&
    Array.isArray(userInfo.userAddresses) &&
    userInfo.userAddresses.length &&
    userInfo.userAddresses[props.index]
  ) {
    const {monfriFrom, monfriTo, saturdayFrom, saturdayTo, sundayFrom, sundayTo} = userInfo.userAddresses[props.index]
    result.monfriFrom = monfriFrom
    result.monfriTo = monfriTo
    result.saturdayFrom = saturdayFrom
    result.saturdayTo = saturdayTo
    result.sundayFrom = sundayFrom
    result.sundayTo = sundayTo
  }
  return result
}

WorkingTime.propTypes = {
  index: PropTypes.number.isRequired
}

WorkingTime.defaultProps = {
  index: 0
}

export default connect(mapStateToProps)(WorkingTime)
